export const createHDFCErgoOptimaRestoreReqBody = (
  data,
  initialValues,
  quickQuoteValues
) => {
  let updatedReqBody = {};
  let proposerDetail;
  let insuredsArray = [];
  let nomineeDetails;
  let medicalQuestions = [];
  Object.entries(data).forEach((entry, index) => {
    switch (entry[0]) {
      case "primaryDetail":
        entry[1].forEach((item, ind) => {
          insuredsArray.push(item);
        });
        break;
      case "dependentDetail":
        proposerDetail = { ...entry[1] };
        break;
      case "nomineeDetail":
        nomineeDetails = { ...entry[1] };
        break;
      case "medicalQuestions":
        medicalQuestions = entry[1];
        break;
      default:
        break;
    }
  });
  // console.log("before processing medicalQuestions", medicalQuestions)
  medicalQuestions = medicalQuestions.map((insuredsQuestions) => {
    const questionList = insuredsQuestions["questionlist"];
    const newQuestionList = [];

    for (const question in questionList) {
      if (Object.hasOwnProperty.call(questionList, question)) {
        const answer = questionList[question];
        newQuestionList.push({ question_id: question, isChecked: answer });
      }
    }

    return { ...insuredsQuestions, questionlist: newQuestionList };
  });
  // console.log("after processing medicalQuestions", medicalQuestions)
  let proposer_details = Object.keys(proposerDetail)
    .filter((key) => !["SameAsAboveOptimaRestore"].includes(key))
    .reduce((res, key) => ((res[key] = proposerDetail[key]), res), {});


  // add ons list
  insuredsArray.forEach((insured, index) => {

      const addOnsList = proposerDetail?.addOnsList[0];
      if(insured.relationship !== "99"){
        addOnsList.ipaSa="0";
        addOnsList.ipaRiderCheck="false";
      }
      if (addOnsList?.hdcCheck === "") {
        addOnsList.hdcCheck = "false";
      }
      if (addOnsList?.ipaRiderCheck === "") {
        addOnsList.ipaRiderCheck = "false";
      }
      if (addOnsList?.pCheck === "") {
        addOnsList.pCheck = "false";
      }
      if (addOnsList?.unlimitedRiderCheck === "") {
        addOnsList.unlimitedRiderCheck = "false";
      }
      insuredsArray[index] = { ...insured, ...addOnsList };
      
  });
  delete proposer_details?.addOnsList;
  // TODO: Is any of the insured pregnant? If yes please mention the expected date of delivery*
  updatedReqBody = {
    appID: "",
    stpNstpFlag: "",
    familyPlan: quickQuoteValues?.familyPlan,
    selectedProduct: {
      prodCd: quickQuoteValues?.policyProduct_code,
    },
    proposer: { ...proposer_details },
    nomineeDetails: { ...nomineeDetails },
    createdDate: Date.now(),
    memberDetailsList: insuredsArray,
    medical: medicalQuestions,
    agentID: null,
    agent: {
      agentId: null,
      initiativeCd: "3000", // TODO: What is this?
    },
    policyStartDate: Date.now(),
  };

  return updatedReqBody;
};
